// extracted by mini-css-extract-plugin
export default {"main":"main_main__IjKCx","info":"main_info__zf5FE"};